var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "shadow-settings-wrapper" }, [
    !_setup.props.isPreview
      ? _c("section", { staticClass: "shadow-section" }, [
          _c(
            "div",
            {
              staticClass: "shadow-grid-wrapper",
              attrs: { role: "group", "aria-label": "Shadow type" },
            },
            _vm._l(_setup.shadowOptions, function (option) {
              return _c(
                "div",
                {
                  key: option.type,
                  staticClass: "shadow-thumb",
                  class: {
                    selected: _setup.model.shadowType === option.type,
                    disabled: _setup.disabled,
                  },
                  attrs: {
                    role: "button",
                    tabindex: _setup.disabled ? -1 : 0,
                    "aria-pressed": _setup.model.shadowType === option.type,
                    "aria-disabled": _setup.disabled,
                    "aria-label": option.label,
                  },
                  on: {
                    click: function ($event) {
                      return _setup.selectType(option.type)
                    },
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.preventDefault()
                        return _setup.selectType(option.type)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar",
                          ])
                        )
                          return null
                        $event.preventDefault()
                        return _setup.selectType(option.type)
                      },
                    ],
                  },
                },
                [
                  _c("img", {
                    staticClass: "shadow-image",
                    attrs: { src: option.img, alt: "" },
                  }),
                ]
              )
            }),
            0
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _setup.model.shadowType != null
      ? _c(
          "section",
          { staticClass: "shadow-section" },
          [
            _c(_setup.ColorOptionsClipboardButtons, {
              attrs: {
                title: "Color",
                "can-copy": !_setup.disabled,
                "can-paste": _setup.canPasteColors,
              },
              on: { copy: _setup.onCopyColors, paste: _setup.onPasteColors },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "border-bottom" }),
            _vm._v(" "),
            _c(_setup.ElementLibrarySelector, {
              attrs: {
                disabled: _setup.disabled,
                "element-list": _setup.colors.model.colorsMap,
                "library-id": _setup.colors.model.libraryId,
                "library-type": _setup.COLOR_TYPE,
                "selected-position": _setup.colors.model.option,
                cmyk: _setup.props.cmykMode,
              },
              on: {
                "pick-library": function ($event) {
                  return _setup.colors.pickColorLibrary()
                },
                "remove-library": function ($event) {
                  return _setup.colors.removeColorLibrary()
                },
                "option-selected": _setup.colors.onColorSelected,
                "remove-map-option": function ($event) {
                  return _setup.colors.removeColorOption($event)
                },
                "load-option": (option, value) =>
                  _setup.colors.loadColorIntoElement(option, value),
                "options-reordered": function ($event) {
                  return _setup.colors.onColorOptionsReordered($event)
                },
                "preview-selection": function ($event) {
                  return _setup.colors.previewColorOption($event)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _setup.model.shadowType != null && !_setup.props.isPreview
      ? _c("section", { staticClass: "shadow-section" }, [
          _c("h6", [_vm._v("Settings")]),
          _vm._v(" "),
          _c("div", { staticClass: "border-bottom" }),
          _vm._v(" "),
          _c("div", { staticClass: "row align-items-center" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("label", [
                  _vm._v("Offset: " + _vm._s(_setup.model.shadowOffset) + "%"),
                ]),
                _vm._v(" "),
                _c(_setup.CSlider, {
                  attrs: {
                    value: _setup.model.shadowOffset,
                    formatter: "{value}%",
                    max: 100,
                    disabled: _setup.disabled,
                  },
                  on: { input: _vm.shadow.changeShadowOffset },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("label", [
                  _vm._v("Angle: " + _vm._s(_setup.model.shadowAngle) + "°"),
                ]),
                _vm._v(" "),
                _c(_setup.CSlider, {
                  attrs: {
                    value: _setup.model.shadowAngle,
                    formatter: "{value}°",
                    max: 365,
                    disabled: _setup.disabled,
                  },
                  on: { input: _vm.shadow.changeShadowAngle },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row align-items-center" }, [
            _setup.model.shadowType === _setup.BLURRED_SHADOW
              ? _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("label", [
                      _vm._v("Blur: " + _vm._s(_setup.model.shadowBlur) + "%"),
                    ]),
                    _vm._v(" "),
                    _c(_setup.CSlider, {
                      attrs: {
                        value: _setup.model.shadowBlur,
                        formatter: "{value}%",
                        max: 100,
                        disabled: _setup.disabled,
                      },
                      on: { input: _vm.shadow.changeShadowBlur },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }